import { Injectable } from '@angular/core';
import { Converter } from '../../converter.interface';
import { isNullOrUndefined } from 'util';
import { StringUtils } from 'src/app/services/utils/string.utils';
import { TaskCommentObject } from 'src/app/models/tasks/tasks-details/tasks-details-comments/task-comment.model';

@Injectable({
    providedIn: 'root'
})
export class TaskCommentsConverter implements Converter<Array<TaskCommentObject>>{

    public convert(input: any): Array<TaskCommentObject> {

        try {
            if (isNullOrUndefined(input)) return new Array<TaskCommentObject>();

            let comments: Array<TaskCommentObject> = new Array<TaskCommentObject>();
            for (let commentData of input.comments) {
                const comment: TaskCommentObject = new TaskCommentObject(StringUtils.default(commentData.addedBy),
                    commentData.addedAt,
                    StringUtils.default(commentData.comment));
                comments.push(comment);
            }
            return comments;
        } catch (error) {
            console.error(error);
            return new Array<TaskCommentObject>();
        }
    }

}
